var _path, _path2, _circle, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnResourceCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3001 17.795C29.059 17.7861 29.945 17.7861 31.0001 17.7861V31.4662C26.68 31.4662 24.52 31.4662 22 32.9062C19.48 31.4662 18.76 31.4662 13 31.4662V17.7861C14.0551 17.7861 14.9411 17.7861 15.7 17.795",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26L22 32",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0001,
    cy: 18.7438,
    r: 6.90003,
    stroke: "#172664",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5501 11.9932C21.5501 11.9932 18.8501 14.8655 18.8501 18.7432C18.8501 22.6209 21.5501 25.4932 21.5501 25.4932",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4501 11.9932C22.4501 11.9932 25.1501 14.8655 25.1501 18.7432C25.1501 22.6209 22.4501 25.4932 22.4501 25.4932",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.962 18.5493C14.962 18.5493 18.022 19.4639 22.1531 19.4639C26.2841 19.4639 29.0381 18.5493 29.0381 18.5493",
    stroke: "#172664",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnResourceCenter);
export default __webpack_public_path__ + "static/media/btn_resource_center.405a4724d7fb593957ea167eb10d259c.svg";
export { ForwardRef as ReactComponent };